// WEBGL BUILT-IN TYPES
import GL from 'gl-constants';
import assert from 'assert';

export { GL };
export default GL;

// Resolve a WebGL enumeration name (returns itself if already a number)
export function glGet(name) {
  // assertWebGLContext(gl);
  var value = name;
  if (typeof name === 'string') {
    value = GL[name];
    assert(value !== undefined, 'Accessing GL.' + name);
  }
  return value;
}

export function glKey(value) {
  for (var key in GL) {
    if (GL[key] === value) {
      return 'GL.' + key;
    }
  }
  return String(value);
}

// Extract constants from WebGL prototype
// function getWebGLConstants() {
//   const constants = {};
//   const WebGLContext =
//     glob.WebGL2RenderingContext || WebGLRenderingContext;
//   for (const key in WebGLContext.prototype) {
//     if (typeof WebGLContext[key] !== 'function') {
//       constants[key] = WebGLContext[key];
//     }
//   }
//   Object.freeze(constants);
//   return constants;
// }

// const GL = getWebGLConstants();
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/webgl/webgl-constants.js
// module id = 49
// module chunks = 0